
import { Observable } from './druid/./druid/Observable';
import { merge } from './druid/./druid/operator/merge';

Observable.prototype.merge = merge;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    merge: typeof merge;
  }
}